import React, { createContext, useContext, useState, useEffect,} from 'react';

const STORAGE_KEY = 'seyHot_travels';
const TravelContext = createContext();

export const TravelProvider = ({ children }) => {
  const [travels, setTravels] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) setTravels(JSON.parse(saved));
  }, []);

  const addTravel = (travelObj) => {
    const updated = [...travels, travelObj];
    setTravels(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const removeTravel = (id) => {
    const updated = travels.filter(t => t.id !== id);
    setTravels(updated);
    localStorage.setItem('seyHot_travels', JSON.stringify(updated));
  };

  return (
    <TravelContext.Provider value={{ travels, addTravel, removeTravel }}>
      {children}
    </TravelContext.Provider>
  );
};

export const useTravels = () => useContext(TravelContext);
